"use client"

import { GitCompareArrows } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GitCompareArrowsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GitCompareArrowsIcon = component(Icon)({ as: GitCompareArrows })
